import {Box, Stack, Typography, useTheme} from '@mui/material';

// Components
import ExpandableBox from 'src/components/common/ExpandableBox';
import TableHorizontal from 'src/components/TableHorizontal';
import { renderTextOrDefault, renderNumberOrDefault } from 'src/utils/helpers/stringHelpers';
import {formatValueUSD} from "src/utils/helpers/utilities";
import TooltipFormLabel from "src/components/common/TooltipFormLabel";
import {useTranslation} from "react-i18next";

// Utilities

const PackingInformation = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();
  const {t} = useTranslation();
  const configColumn = [
    {
      label: 'Quantity',
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderNumberOrDefault(data.transaction?.quantity)}
        </Typography>
      ),
    },
    {
      label: 'Quantity Unit',
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderTextOrDefault(data.transaction?.quantity_unit)}
        </Typography>
      ),
    },
    {
      label: `Weight (${renderTextOrDefault(tradeDataDetail.transaction?.weight_unit)})`,
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderNumberOrDefault(data.transaction?.weight)}
        </Typography>
      ),
    },
    // {
    //   label: 'Original Weight',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(numeral(data.original_weight).format('O,O'))}
    //     </Typography>
    //   ),
    // },
    // {
    //   label: 'Original Unit',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(numeral(data.original_unit).format('O,O'))}
    //     </Typography>
    //   ),
    // },
    // {
    //   label: 'WGT (KGS)',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(data.wgt)}
    //     </Typography>
    //   ),
    // },
    {
      label: (
        <Stack direction={'row'} gap={1} alignItems={'center'}>
          <Box>Unit Price</Box>
          <TooltipFormLabel title={t('trade_data.value_usd.disclaimer.tooltips')} />
        </Stack>
      ),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {formatValueUSD(data?.transaction?.unit_value)}
        </Typography>
      ),
    },
    {
      label: (
        <Stack direction={'row'} gap={1} alignItems={'center'}>
          <Box>{t('market_analytics.table.column_name.value')}</Box>
          <TooltipFormLabel title={t('trade_data.value_usd.disclaimer.tooltips')} />
        </Stack>
      ),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {formatValueUSD(data?.transaction?.value_usd)}
        </Typography>
      ),
    },
    // {
    //   label: 'Invoice Value',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(data.invoice_value)}
    //     </Typography>
    //   ),
    // },
    // {
    //   label: 'Applied Tariffs',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(data.applied_tariffs)}
    //     </Typography>
    //   ),
    // },
    // {
    //   label: 'Freight Value',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(data.freight_value)}
    //     </Typography>
    //   ),
    // },
    // {
    //   label: 'Insurance Value',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(data.insurance_value)}
    //     </Typography>
    //   ),
    // },
    // {
    //   label: 'Total Cost (Inclusive of Taxes/Tariffs)',
    //   renderCell: (data: IBillOfLadingDetail) => (
    //     <Typography color={'text.secondary'} variant="body2">
    //       {renderTextOrDefault(data.total_cost)}
    //     </Typography>
    //   ),
    // },
  ];

  return (
    <ExpandableBox title="Packing Information" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <TableHorizontal colKeyWidth={350} configColumn={configColumn} data={tradeDataDetail} />
      </Box>
    </ExpandableBox>
  );
};

export default PackingInformation;
